import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let TenantKeyService = class TenantKeyService {
    constructor(api) {
        this.api = api;
    }
    async getTenantKey(companyId) {
        const res = await this.api.getTenantKeyList(companyId);
        return res?.data;
    }
    async getRechargeRecord(data) {
        const res = await this.api.getRechargeRecord(data);
        return res?.data;
    }
    async getTenantDeveloper(data) {
        const res = await this.api.getTenantDeveloper(data);
        return res?.data;
    }
};
TenantKeyService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OpenApi)),
    __metadata("design:paramtypes", [Object])
], TenantKeyService);
export { TenantKeyService };
